import { UserRole } from '@/features/user/constants';
import { PROJECT_TYPES, ProjectType, ProjectUserRoles } from '@/features/projects/constants';
import { Project } from '@/features/projects/types';

export const canManageProject = (
  project: Pick<Project, 'roleName'> | undefined,
  organizationRole: UserRole | undefined,
) => {
  return (
    project?.roleName === ProjectUserRoles.ADMIN || organizationRole === UserRole.ORGANIZATION_ADMIN
  );
};

export const getProjectClientDisplay = (
  project: Pick<Project, 'companyId' | 'companyName'>,
  organizationName: string,
): { name: string; isSelf: boolean } | null => {
  if (project.companyName) {
    return {
      name: project.companyName,
      isSelf: organizationName === project.companyName,
    };
  }

  if (!project.companyId && organizationName) {
    return { name: organizationName, isSelf: true };
  }

  return null;
};

export const toProjectType = (value: string | null | undefined): ProjectType | undefined =>
  PROJECT_TYPES.find((known) => known === value?.toUpperCase());
